// extracted by mini-css-extract-plugin
export default {"inputContainer":"Input_inputContainer__1OSHO","textarea":"Input_textarea__2BfCa","sendButton":"Input_sendButton__jZdYP","arrowIcon":"Input_arrowIcon__u5vuP"};